import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import Spin from 'antd/lib/spin';

type SpinnerProps = {
  isLoading: boolean;
  children?: ReactNode;
};

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ({ isLoading, children = null }: SpinnerProps) =>
  isLoading ? (
    <SpinnerWrapper>
      <Spin />
    </SpinnerWrapper>
  ) : (
    children
  );
